import React, { useState } from "react";
import { Box } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/App.css";
import { hollywoodBg } from './assets';
import MovieForm from "./components/MovieForm";
import MovieDisplay from "./components/MovieDisplay";

function App() {
  const [movie, setMovie] = useState("");
  const [movieFact, setMovieFact] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  const handleCaptchaChange = (value) => {
    setIsCaptchaVerified(!!value);
  };

  const getMovieFact = async (movieTitle) => {
    if (!isCaptchaVerified) {
      toast.error("Please complete the captcha first");
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch("https://whitehorse.pythonanywhere.com/get_movie_fact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          movie_name: movieTitle,
          captcha_token: isCaptchaVerified
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch movie fact");
      }

      const data = await response.json();
      setMovieFact(data.fact || data.message);
    } catch (error) {
      toast.error("Unable to get movie fact. Please try again.");
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app" style={{
      background: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url(${hollywoodBg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center 20%',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed'
    }}>
      <div className="app-header">
        <h1 className="app-title">Movie Fact App 🎬</h1>
        <p className="app-tagline" style={{
          color: 'white',
          fontSize: '1.2rem',
          textAlign: 'center',
          marginTop: '10px',
          marginBottom: '20px',
          fontWeight: '300',
          textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
        }}>
          Add your favorite movie and get a fun fact about it instantly!
        </p>
        
        <div className="instructions" style={{
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          padding: '20px',
          borderRadius: '8px',
          maxWidth: '600px',
          margin: '0 auto 30px auto',
          color: 'white',
          textAlign: 'left'
        }}>
          <h3 style={{
            fontSize: '1.1rem',
            marginBottom: '15px',
            color: '#1976d2',
            textAlign: 'center'
          }}>
            How to Get Your Movie Fact:
          </h3>
          <ol style={{
            paddingLeft: '25px',
            lineHeight: '1.6',
            margin: '0'
          }}>
            <li>Enter your favorite movie title in the input field below</li>
            <li>Complete the reCAPTCHA verification by checking the box</li>
            <li>Click the "Get Fact" button</li>
            <li>Instantly receive an interesting fact about your chosen movie!</li>
          </ol>
          <p style={{
            marginTop: '15px',
            fontSize: '0.9rem',
            color: '#bbbbbb',
            fontStyle: 'italic'
          }}>
            Note: Make sure to enter the complete and correct movie title for the best results.
          </p>
        </div>
      </div>

      <Box sx={{ maxWidth: 600, margin: '0 auto', padding: 2 }}>
        <MovieForm 
          movie={movie}
          setMovie={setMovie}
          onSubmit={() => getMovieFact(movie)}
          isLoading={isLoading}
        />

        <Box sx={{ my: 3 }}>
          <ReCAPTCHA
            sitekey="6LcNSgorAAAAABetaz54iHxBN0btKbLUGTXnUaIa"
            onChange={handleCaptchaChange}
          />
        </Box>

        {movieFact && (
          <MovieDisplay 
            movieTitle={movie}
            movieFact={movieFact}
          />
        )}
      </Box>

      <ToastContainer />
    </div>
  );
}

export default App;
